export type SplashScreenState = {
  url: string | null
  pendingUrl: string | null
}

export enum SplashScreenActionTypes {
  LOAD_SPLASH_SCREEN = 'LOAD_SPLASH_SCREEN',
  STORE_PENDING_SPLASH_SCREEN = 'STORE_PENDING_SPLASH_SCREEN',
  CONFIRM_SPLASH_SCREEN = 'CONFIRM_SPLASH_SCREEN',
  CLEAR_SPLASH_SCREEN = 'CLEAR_SPLASH_SCREEN',
}
